import { render, staticRenderFns } from "./ContactsPage.vue?vue&type=template&id=2d1d0e9d&"
import script from "./ContactsPage.vue?vue&type=script&lang=js&"
export * from "./ContactsPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactsPage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports